import type { UUID } from '$domain/types';

export function newId(): UUID {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function nowIso(): string {
  return new Date().toISOString();
}

export function notDeleted<T extends { deletedAt?: string | null }>(entity: T): boolean {
  return entity.deletedAt === undefined || entity.deletedAt === null;
}

export function endOfDayIso(d: Date = new Date()): string {
  const end = new Date(d);
  end.setHours(23, 59, 59, 999);
  return end.toISOString();
}

export function estimatePayloadBytes(payload: unknown): number {
  try {
    const json = JSON.stringify(payload);
    if (typeof Blob !== 'undefined') {
      return new Blob([json]).size;
    }
    if (typeof TextEncoder !== 'undefined') {
      return new TextEncoder().encode(json).length;
    }
    return json.length;
  } catch {
    return 1024;
  }
}